export const MOVEMENT_TYPE_PT: Record<string, string> = {
  IN: "Entrada",
  OUT: "Saida",
  TRANSFER: "Transferencia",
};

export const MOVEMENT_ORIGIN_PT: Record<string, string> = {
  MANUAL: "Manual",
  PAYABLE: "Contas a pagar",
  RECEIVABLE: "Contas a receber",
  ESTORNO_PAGAMENTO: "Estorno pagamento",
  ESTORNO_RECEBIMENTO: "Estorno recebimento",
  OPEN_FINANCE: "Open Finance",
  CREDIT_CARD: "Cartao de credito",
  PARTNER: "Socio",
  INITIAL_BALANCE: "Saldo inicial",
};

export const MOVEMENT_NATURE_PT: Record<string, string> = {
  OPEX: "OPEX",
  CAPEX: "CAPEX",
  FINANCE: "Financeiro",
  OTHER: "Outros",
};
